import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-row gap-1 items-center text-6 font-bold uppercase mb-4" }

import { computed, ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import store from "@/store";

import { toast } from "@/common/utils/toast";

import {
  affiliateList,
  affiliateDelete,
  affiliateCreate,
  affiliateUpdate,
} from "@/common/api/rest/affiliate";

import type {
  AffiliateType,
  AffiliatePayloadType,
} from "@/common/types/affiliate";

import { RegisterTheme } from "@/common/themes";
import { technicalForm } from "@/components";
import {
  baseConfirm,
  baseModal,
  baseTable,
  svgIcon,
} from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { t, tm } = useI18n();

const route = useRoute();

const tableHeader = [
  { key: "name", label: "Nome" },
  { key: "email", label: "Email" },
  { key: "type", label: "Tipo" },
  { key: "status", label: "Status" },
];

const accountId = computed(() => route.params.id as string);

const tableData = ref<AffiliateType[]>([]);
const limited = ref(false);
const isEdit = ref(false);

const selected = ref<AffiliateType | null>(null);
const payload = ref<AffiliatePayloadType | null>(null);

const limit = ref<number>(5);
const page = ref<number>(0);
const pages = ref<number>(0);
const search = ref<string>("");
const searched = ref<number>(0);
const total = ref<number>(0);

const showConfirmDel = ref(false);
const showModal = ref(false);

const types = computed(() => tm("technical.types") as Record<string, string>);

function checkLimit() {
  // affiliateLimit(accountId.value).then((response) => {
  //   const { success, data, message } = response;
  //   if (success) {
  //     limited.value = data.limited;
  //   } else {
  //     toast({ message: message, type: "error" });
  //   }
  // });
}

function fetchTechnicals() {
  affiliateList(accountId.value, {
    page: page.value,
    limit: limit.value,
    search: search.value,
  })
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        tableData.value = data.list;
        page.value = data.infos.page;
        pages.value = data.infos.pages;
        total.value = data.infos.total;
        searched.value = data.infos.count;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function removeItem(data: AffiliateType) {
  selected.value = data;
  showConfirmDel.value = true;
}

function confirmRemoveItem() {
  if (!selected.value) return;

  affiliateDelete(accountId.value, selected.value.affiliate_id)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        toast({ message: message, type: "success" });
        fetchTechnicals();
        checkLimit();
      } else {
        toast({ message: message, type: "error" });
      }
      cancelRemoveItem();
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
      cancelRemoveItem();
    });
}

function cancelRemoveItem() {
  selected.value = null;
  showConfirmDel.value = false;
}

function openModal(data?: AffiliateType) {
  if (data) {
    selected.value = data;
    isEdit.value = true;
    showModal.value = true;
    return;
  }

  if (limited.value) {
    toast({ message: t("technical.texts.technical_limit"), type: "error" });
    return;
  }

  showModal.value = true;
}

function closeModal() {
  showModal.value = false;
  isEdit.value = false;
  selected.value = null;
}

function addTechnical() {
  if (limited.value) {
    toast({ message: t("technical.texts.technical_limit"), type: "error" });
    return;
  }

  if (!payload.value) return;

  store.commit("SET_LOADING", true);

  affiliateCreate(accountId.value, payload.value)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        closeModal();
        fetchTechnicals();
        checkLimit();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

function editTechnical() {
  if (!selected.value) return;

  affiliateUpdate(
    accountId.value,
    selected.value.affiliate_id,
    payload.value as AffiliatePayloadType,
  )
    .then((response) => {
      const { success, message } = response;

      if (success) {
        closeModal();
        fetchTechnicals();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function submitPayload() {
  if (isEdit.value) {
    editTechnical();
  } else {
    addTechnical();
  }
}

function searchItem(value: string) {
  search.value = value;
  fetchTechnicals();
}

function changePage(value: number) {
  page.value = value;
  fetchTechnicals();
}

onMounted(() => {
  if (accountId.value) {
    fetchTechnicals();
    checkLimit();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(RegisterTheme), { "tab-active": "technical" }, {
      title: _withCtx(() => [
        _createVNode(_unref(svgIcon), {
          icon: "technical",
          size: "2rem"
        }),
        _cache[4] || (_cache[4] = _createTextVNode(" AFILIADOS ", -1))
      ]),
      content: _withCtx(() => [
        _createVNode(_unref(baseTable), {
          header: tableHeader,
          data: tableData.value,
          limit: limit.value,
          page: page.value,
          pages: pages.value,
          total: total.value,
          searched: searched.value,
          options: true,
          edit: true,
          del: true,
          "onChange:page": changePage,
          onSearching: searchItem,
          "onBtn:add": _cache[0] || (_cache[0] = ($event: any) => (openModal())),
          "onBtn:edit": openModal,
          "onBtn:del": removeItem
        }, {
          name: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(data.name), 1)
          ]),
          type: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(types.value[data.type]), 1)
          ]),
          status: _withCtx(({ data }) => [
            _createTextVNode(_toDisplayString(_unref(t)(`common.labels.${data.status.toLowerCase()}`)), 1)
          ]),
          _: 1
        }, 8, ["data", "limit", "page", "pages", "total", "searched"])
      ]),
      _: 1
    }),
    _createVNode(_unref(baseModal), {
      show: showModal.value,
      "show-button-confirm": true,
      "button-confirm": _unref(t)('common.labels.save'),
      "button-close": _unref(t)('common.labels.cancel'),
      onClose: _cache[2] || (_cache[2] = ($event: any) => (closeModal())),
      onConfirm: _cache[3] || (_cache[3] = ($event: any) => (submitPayload()))
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_unref(svgIcon), {
            icon: "technical",
            size: "2.5rem"
          }),
          _createTextVNode(" " + _toDisplayString(_unref(t)("technical.texts.add_technical")), 1)
        ])
      ]),
      content: _withCtx(() => [
        _createVNode(_unref(technicalForm), {
          data: selected.value,
          onUpdateData: _cache[1] || (_cache[1] = ($event: any) => (payload.value = $event))
        }, null, 8, ["data"])
      ]),
      _: 1
    }, 8, ["show", "button-confirm", "button-close"]),
    _createVNode(_unref(baseConfirm), {
      show: showConfirmDel.value,
      title: 
      _unref(t)('common.labels.remove', {
        concat: _unref(t)('common.labels.technical'),
      }).toUpperCase()
    ,
      message: 
      _unref(t)('common.texts.remove_message', {
        concat: selected.value?.name,
      })
    ,
      onCancel: cancelRemoveItem,
      onConfirm: confirmRemoveItem
    }, null, 8, ["show", "title", "message"])
  ], 64))
}
}

})